var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"occupancy-by-room-banner"},[_c('div',{staticClass:"occupancy-by-room-banner__content"},[_c('i',{staticClass:"icon sm rhg-font-icon--user"}),_c('span',{staticClass:"occupancy-by-room-banner__text",domProps:{"innerHTML":_vm._s(_vm.occupancyByRoomLabel)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }